import { createHandlers } from '@redux-async-module/handlers-utils';
import { createReducer } from '@redux-basic-module/reducer-utils';

import { retrieveDraft } from './actions';
import { INITIAL_STATE, NAMESPACE } from './types';

const HANDLERS = createHandlers(retrieveDraft, INITIAL_STATE);

export const reducer = createReducer(NAMESPACE, INITIAL_STATE, HANDLERS);
